import React, { useRef, useState } from 'react';

import { Tooltip } from '@/components/ui/tooltips/Tooltip';
import { colors } from '@/assets/styles/colors';
import { useTranslation } from '@/i18n';


/**
 * Blue dot + hover tooltip shown next to a shift's code when it is assigned
 * (`hasAssignments === true`) — signals that the shift is locked (read-only) in Edit.
 */
export const ShiftAssignedIndicator: React.FC = () => {
  const { t: translate } = useTranslation('schedule');
  const anchorRef = useRef<HTMLSpanElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <span
      ref={anchorRef}
      className="inline-block ml-1 align-middle"
      style={{
        position: 'relative',
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: colors.important.main,
        cursor: 'help',
      }}
      tabIndex={0}
      aria-label={translate('shift.columns.assignedTooltip')}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onFocus={() => setShowTooltip(true)}
      onBlur={() => setShowTooltip(false)}
      data-testid="shift-assigned-indicator"
    >
      {showTooltip && (
        <Tooltip
          body={translate('shift.columns.assignedTooltip')}
          anchorRef={anchorRef}
          strategy="absolute"
          placement="top"
          maxWidth={280}
        />
      )}
    </span>
  );
};

export default ShiftAssignedIndicator;
